import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

/**
 * Displays a simple message informing user that they don't have access, along with a button to get back to start.
 */
@Component({
	selector: 'app-forbidden',
	imports: [CardModule, ButtonModule, RouterLink],
	templateUrl: './forbidden.component.html',
	styleUrl: './forbidden.component.scss',
})
export class ForbiddenComponent {}
